/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_TitleInputs */

const en_consent_title = /** @type {(inputs: Consent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies and analytics`)
};

/**
* | output |
* | --- |
* | "Cookies and analytics" |
*
* @param {Consent_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_title = /** @type {((inputs?: Consent_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_title(inputs)
});